export default __webpack_public_path__ + "static/media/greenCheckCircle.968ecb85.svg";